import i18next from 'i18next';
import React, { useState } from 'react';

import { TableContainer, Table, ToggleButton, ChevronIcon } from './styledComponents';

/**
 * Composant de tableau markdown avec système de dépliement automatique
 * @param {React.ReactNode} children - Contenu du tableau
 * @param {number} maxRows - Nombre maximum de lignes avant dépliement (défaut: 15)
 * @param {Object} props - Autres propriétés du tableau
 */
const CollapsibleTable = ({ children, maxRows = 10, ...props }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Compter le nombre de lignes dans le tableau
  const tableRows =
    React.Children.toArray(children).find((child) => child.type === 'tbody')?.props?.children || [];

  const rowCount = Array.isArray(tableRows) ? tableRows.length : 1;
  const shouldCollapse = rowCount > maxRows;

  if (!shouldCollapse) {
    // Si le tableau a maxRows lignes ou moins, l'afficher normalement
    return (
      <TableContainer>
        <Table {...props}>{children}</Table>
      </TableContainer>
    );
  }

  // Fonction pour limiter les lignes affichées
  const limitedChildren = React.Children.map(children, (child) => {
    if (child.type === 'tbody') {
      const tbody = child.props.children;
      const limitedRows = isExpanded ? tbody : tbody.slice(0, maxRows);
      return React.cloneElement(child, {}, limitedRows);
    }
    return child;
  });

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const hiddenRowsCount = rowCount - maxRows;

  return (
    <TableContainer>
      <Table {...props}>{limitedChildren}</Table>
      <ToggleButton onClick={toggleExpanded}>
        <ChevronIcon isExpanded={isExpanded} />
        {isExpanded
          ? i18next.t('AGENT.AGENT.TABLE_SHOW_LESS')
          : i18next.t('AGENT.AGENT.TABLE_SHOW_MORE', { count: hiddenRowsCount })}
      </ToggleButton>
    </TableContainer>
  );
};

export default CollapsibleTable;
